<template>
  <div>
    <!-- <div> -->
      Length
      <el-input-number v-model="length" @change="handleChangeWidth" :min="100" :max="1000"></el-input-number>
    <!-- </div> -->
    <!-- <div> -->
      Width
      <el-input-number v-model="width" @change="handleChangeLength" :min="100" :max="1000"></el-input-number>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'SiteMapSettings',
  props: { config: { type: Object, default: () => {} } },
  data() {
    return {
      length: 0,
      width: 0,
    };
  },
  mounted() {
    this.length = this.config.length;
    this.width = this.config.width;
  },
  methods: {
    handleChangeLength(e) {
      console.log(e);
    },
    handleChangeWidth(e) {
      console.log(e);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SiteMapSettings.vue